import React from 'react';
import { Mui, MuiStyles } from '@osu/react-ui';

const useStyles = theme => {
    return {
    formControl: {
        margin: theme.spacing(1),
        minWidth: 250,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}
};

const ReviewerSelectBox = ({ label, value, array, handleChange, type, name }) => {
const classes = useStyles(MuiStyles.useTheme());

    return (
        <Mui.FormControl variant="outlined" sx={classes.formControl}>
            {type === 'number' ? (
                <Mui.TextField
                    label={label}
                    id={`${label}-input`}
                    type="number"
                    inputProps={{min: 0, max: 10}}
                    value={value ?? 0}
                    name={name}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true, //this forces label to always be on top
                    }}
                />  
            ) : (
                <>
                <Mui.InputLabel id={`${label}-label`}>{label}</Mui.InputLabel>  
                <Mui.Select
                    label={label}
                    labelId={`${label}-label`}
                    id={`${label}-selector`}
                    value={value}
                    name={name}
                    onChange={handleChange}
                >
                    {array?.map?.((item) => (
                        <Mui.MenuItem key={item} value={item}>
                            {item}
                        </Mui.MenuItem>
                    ))}
                </Mui.Select>
            </>
            )}
        </Mui.FormControl>
    );
};

export default ReviewerSelectBox;